import * as Sentry from "@sentry/react";
import { getBooleanFromEnv, getVariableFromEnv } from "./common/utilities/env";
import { replayIntegration } from "@sentry/react";

const environment = getVariableFromEnv("ENVIRONMENT", "development");
const version = getVariableFromEnv("VERSION");
const dsn = getVariableFromEnv("SENTRY_DSN");
const onPrem = getBooleanFromEnv("ON_PREM");

// Only initialize Sentry if not on-premise and DSN is provided
if (dsn && !onPrem) {
  try {
    Sentry.init({
      dsn,
      environment,
      release: version,
      integrations: [
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampleRate: environment === "production" ? 0.1 : 0.05,
      normalizeDepth: 4,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: environment === "development" ? 0 : 1,
      ignoreErrors: [
        "ResizeObserver loop completed with undelivered notifications.",
      ],
    });
  } catch (e) {
    console.error("failed to setup Sentry", e);
  }
}

export default Sentry;
